/* tslint:disable */
/* eslint-disable */
/* @relayHash cfdeb5757f12f2bba093da0fa4bc451d */

import { ConcreteRequest } from "relay-runtime";
export type CandidatesPageQueryVariables = {
    name: string;
};
export type CandidatesPageQueryResponse = {
    readonly candidates: {
        readonly edges: ReadonlyArray<{
            readonly id: string;
            readonly email: string;
            readonly firstName: string;
            readonly lastName: string;
        } | null> | null;
    } | null;
};
export type CandidatesPageQuery = {
    readonly response: CandidatesPageQueryResponse;
    readonly variables: CandidatesPageQueryVariables;
};



/*
query CandidatesPageQuery(
  $name: String!
) {
  candidates(filter: {name: $name}, page: {limit: 8}) {
    edges {
      id
      email
      firstName
      lastName
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "name",
            "type": "String!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "candidates",
            "storageKey": null,
            "args": [
                {
                    "kind": "ObjectValue",
                    "name": "filter",
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "name",
                            "variableName": "name"
                        }
                    ]
                },
                {
                    "kind": "Literal",
                    "name": "page",
                    "value": {
                        "limit": 8
                    }
                }
            ],
            "concreteType": "CandidatePage",
            "plural": false,
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Candidate",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "id",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "email",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "firstName",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "lastName",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                }
            ]
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "CandidatesPageQuery",
            "type": "Query",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "CandidatesPageQuery",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "params": {
            "operationKind": "query",
            "name": "CandidatesPageQuery",
            "id": null,
            "text": "query CandidatesPageQuery(\n  $name: String!\n) {\n  candidates(filter: {name: $name}, page: {limit: 8}) {\n    edges {\n      id\n      email\n      firstName\n      lastName\n    }\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '2669b582ebb3199e9b189961bc1753b9';
export default node;
